import React, { useState } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";

export default function AdminMiseAJourMarqueId() {
  const [resultats, setResultats] = useState([]);
  const [enCours, setEnCours] = useState(false);

  const lancerMiseAJour = async () => {
    setEnCours(true);
    const log = [];

    try {
      // 1. Récupérer toutes les marques avec leur nom et leur ID
      const marquesSnap = await getDocs(collection(db, "marques"));
      const mapNomVersId = {};
      marquesSnap.forEach((docSnap) => {
        const data = docSnap.data();
        if (data.nom) {
          mapNomVersId[data.nom] = docSnap.id;
        }
      });

      // 2. Récupérer tous les véhicules
      const vehiculesSnap = await getDocs(collection(db, "vehicules_auto"));
      for (const vehicule of vehiculesSnap.docs) {
        const data = vehicule.data();
        const vehiculeRef = doc(db, "vehicules_auto", vehicule.id);
        const nomMarque = data.marque;

        if (!data.marqueId && mapNomVersId[nomMarque]) {
          await updateDoc(vehiculeRef, {
            marqueId: mapNomVersId[nomMarque],
          });
          log.push(`✅ ${vehicule.id} mis à jour avec marqueId = ${mapNomVersId[nomMarque]}`);
        } else {
          log.push(`⏩ ${vehicule.id} ignoré (déjà à jour ou marque inconnue)`);
        }
      }
    } catch (err) {
      log.push("❌ Erreur : " + err.message);
    }

    setResultats(log);
    setEnCours(false);
  };

  return (
    <div className="container py-5">
      <h2>Mise à jour des véhicules avec marqueId</h2>
      <button className="btn btn-primary mb-3" onClick={lancerMiseAJour} disabled={enCours}>
        {enCours ? "Mise à jour en cours..." : "Lancer la mise à jour"}
      </button>
      <ul className="list-group">
        {resultats.map((msg, idx) => (
          <li key={idx} className="list-group-item small">
            {msg}
          </li>
        ))}
      </ul>
    </div>
  );
}
